/** Display label for client dropdown / autocomplete options. */
export function getClientOptionLabel(client) {
  if (!client) return "";
  const name = (client.fullname || `${client.surname || ""} ${client.name || ""}`.trim());
  if (name && client.client_id) return `${name} — ${client.client_id}`;
  return name || client.client_id || "";
}

export function clientsToSelectOptions(clients) {
  return (Array.isArray(clients) ? clients : []).map((client) => ({
    value: client.client_id,
    label: getClientOptionLabel(client),
    client,
  }));
}

export function filterClientOption(option, inputValue) {
  const input = (inputValue || "").trim().toLowerCase();
  if (!input) return true;
  const c = option.data?.client ?? option.client;
  const parts = [
    option.label,
    c?.client_id,
    c?.fullname,
    c?.surname,
    c?.name,
    c?.email,
  ];
  const haystack = parts.filter(Boolean).join(" ").toLowerCase();
  return haystack.includes(input);
}
